import React, { useEffect } from 'react';

export default function Classifieds() {
  useEffect(() => {
    const prev = document.title;
    document.title = 'Classifieds — Study Hall';
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div
      style={{
        maxWidth: '720px',
        margin: '0 auto',
        padding: '2.5rem 1.5rem 3rem',
        minHeight: '60vh',
      }}
    >
      <h1
        style={{
          fontSize: 'clamp(1.75rem, 4vw, 2.25rem)',
          fontWeight: 700,
          color: '#1a2e22',
          margin: '0 0 0.75rem',
          letterSpacing: '-0.02em',
        }}
      >
        Classifieds
      </h1>
      <p
        style={{
          fontSize: '1.05rem',
          lineHeight: 1.6,
          color: '#415048',
          margin: 0,
        }}
      >
        Member listings and community classifieds will appear here. Check back soon.
      </p>
    </div>
  );
}
